module.exports = {"path":["Dashboard","GroupTour","Add Records"],"submit":"Submit","update":"Update","reset":"Reset","group":"Add Group","groupEdit":"Edit Group","groupError":"Network Error, can not set up group for this transaction. Try again later."}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/create/index.json
// module id = 6Tan
// module chunks = 58